import { useContext } from 'react';

import { SnackBarContext } from '../providers/SnackBarProvider';

const useSnackBar = () => {
  return useContext(SnackBarContext);
};

export default useSnackBar;
